import { logger } from '@/features/shiftCloseouts/logger'
import { useHandleErrorWithToast } from '@/hooks/useHandleErrorWithToast'
import { ApolloError } from '@apollo/client'
import { useEffect } from 'react'

export const useHandleQueryErrorWithToast = (
    error: ApolloError | undefined,
    loading: boolean
): void => {
    const handleError = useHandleErrorWithToast(logger)

    useEffect(() => {
        if (!loading && error) handleError(error)
    }, [error, handleError, loading])
}
